import React, { Component } from 'react';
import classes from './Header.css';
import Container from '../../../hoc/Container/Container';
import Burger from '../../UI/Burger/Burger';
import NavigationLinks from '../../UI/NavigationLinks/NavigationLinks';
import {withRouter} from 'react-router';
class  Header extends Component {
    state = {
        'changeHeaderColor':'transparent'
    }
    navColor = 'var(--color-primary)';

    onScrollHandler = () => {
       if(this.props.location.pathname === '/') {
        let scrollY = window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
      
        if(scrollY >= 250 && this.state.changeHeaderColor === 'transparent') {
          this.setState({'changeHeaderColor':this.navColor});
        }else if(scrollY <= 250 && this.state.changeHeaderColor !== 'transparent') {
          this.setState({'changeHeaderColor':'transparent'});
        }
       } 
      };

    componentDidMount() {
        window.addEventListener('scroll',this.onScrollHandler);
        if (this.props.location.pathname !== '/') {
            this.setState({'changeHeaderColor':this.navColor});
        }
    }

    componentDidUpdate() {
        if( this.props.location.pathname !== '/' && this.state.changeHeaderColor === 'transparent')  {
            this.setState({'changeHeaderColor':this.navColor});
        }
    }

    render() {
        const style = {
            backgroundColor:this.state.changeHeaderColor
        };
        return (
        <header>
        <div style={style} className={classes.appNavWrapper}>
            <Container>
                <nav className={classes.appNav}>
                    <Burger clicked={this.props.burgerClicked} />   
                   <NavigationLinks isNav />
                   <div className={classes.appNavSpacer}></div>
                </nav>
            </Container>
        </div>
    </header>
    )
    }

}

export default  withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Navigation/Header/Header.js